import { IStrings } from 'localization/IStrings';
import { SelectableColumn } from '../SelectableColumn';

export const createColumnRecord = (strings: IStrings): Record<SelectableColumn, string> => {
	return {
		pos: 'Positie',
		key: 'Subscription Key',
		backlog: 'Backlog',
	};
};
